import { useEffect } from 'react';

const useOutsideClick = (ref, cb) => {
    const handleClick = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            cb();
        }
    };

    useEffect(() => {
        // add event listener
        window.addEventListener('click', handleClick);

        // remove event listener on cleanup
        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, []);
};

export default useOutsideClick;
